var App = App || {};

App.SubpagesCallout = (function ($) {
    "use strict";

    function init() {
        $("select.select-page-nav").on("change", function (event) {
            window.location = event.target.value;
        });
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.SubpagesCallout.init();
});